exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Gupx{padding:15px 0 0 15px}.RyC3G{padding:3px 0 8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._1mJ7B{width:20px;color:#888}._1mJ7B>svg{width:12px;height:12px}.heJ1W{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1hnlw{font-size:10px;line-height:12px;color:#888;margin-bottom:4px}._27p5n{font-size:14px;line-height:17px;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_2Gupx",
	"row": "RyC3G",
	"icon": "_1mJ7B",
	"info": "heJ1W",
	"title": "_1hnlw",
	"value": "_27p5n"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertInfo/AdvertInfo.css
// module id = 3294
// module chunks = 32